import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Toolbar from '../../components/common/Toolbar';
import Cards from '../../components/blocks/Cards';
import { getApprovedRetailers, setApprovedRetailersOffset } from '../../store/actions/approvedRetailers';
import Spinner from '../../components/common/Spinner';

function ApprovedRetailersContainer(props) {
  const { getAcceptedInvitationRetailers } = props;

  useEffect(() => {
    getAcceptedInvitationRetailers();
  }, [getAcceptedInvitationRetailers]);

  if (props.isLoading) {
    return <Spinner />;
  }

  return (
    <>
      <Toolbar name="Active Sales Channels" />
      {props.retailers.length > 0 && <Cards {...props} />}
    </>
  );
}

const mapStateToProps = (state) => {
  const { data, count, perPage, isLoading, offset } = state.approvedRetailers;
  const { supplierId } = state.role;

  return {
    retailers: data,
    count,
    perPage,
    isLoading,
    offset,
    supplierId,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getAcceptedInvitationRetailers: () => dispatch(getApprovedRetailers()),
  setPage: (offset) => dispatch(setApprovedRetailersOffset(offset)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ApprovedRetailersContainer);

ApprovedRetailersContainer.propTypes = {
  retailers: PropTypes.array.isRequired,
  getAcceptedInvitationRetailers: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  supplierId: PropTypes.number.isRequired,
};
